// extracted by mini-css-extract-plugin
export default {"surface":"ChatSurface_surface__33kOz","surface__bar":"ChatSurface_surface__bar__mg9yn","surface__chat":"ChatSurface_surface__chat__hnK+P"};